module.exports = __webpack_public_path__ + "od-heart-filled-icon/od-heart-filled-icon-195ef6855f0d0f440a76969688599906.svg";